export default __webpack_public_path__ + "static/media/illu_portfolio.f6293e1f.png";